module.exports = __webpack_public_path__ + "sprite/confetti-0.png";


//////////////////
// WEBPACK FOOTER
// ./sprite/confetti-0.png
// module id = 126
// module chunks = 3